import React from "react";

// YOUTUBE
import YouTube from 'react-youtube'

// STYLES
import styled from "styled-components";

// VIDEO
import VideoBg from '../../video/loop 03.mp4';

// ICONS
import FaPlay from 'react-icons/lib/fa/play'

// COMPONENT
import Mouse from '../../components/mouse/mouse.component';

const opts1 = {
    height: '390',
    width: '640',
    playerVars: {
        autoplay: 0,
        controls: 0,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
        loop: 1,
        playlist: "5revE_ChYWo"
    }
};

const opts2 = {
    height: '390',
    width: '640',
    playerVars: {
        autoplay: 0,
        controls: 0,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
        loop: 1,
        playlist: "hR0ITLPTsw8"
    }
};

// TO DO 
export default class VideoComponent extends React.Component{
    render() {
        let {t, i18n} = this.props;
        return(
            <BackgroundContent>
                {
                    i18n.language === 'pt' &&
                        <YouTube
                            videoId="5revE_ChYWo"
                            opts={opts1}
                            className="youtube"
                            onReady={_onReady}
                        />
                }
                {
                    i18n.language === 'en' &&
                        <YouTube
                            videoId="hR0ITLPTsw8"
                            opts={opts2}
                            className="youtube"
                            onReady={_onReady}
                        />
                }
                <video className="player" width="100" height="100" data-object-fit="cover" autoPlay loop>
                    <source src={VideoBg} type="video/mp4" />
                </video>
                <Overlay></Overlay>
                <ContentVideo>
                    <h1>{t('PROVE PORTUGAL')}</h1>
                    <h2>{t('Pretende dar a conhecer os locais onde a')}<span> {t('Gastronomia Portuguesa')}</span> {t('pode ser saboreada')}</h2>
                    <Button className="btnOuline" id="play-video"><span><FaPlay/></span>{t('Ver Video')}</Button>
                </ContentVideo>
                <Mouse/>
            </BackgroundContent>
        )
    }
}


const _onReady = function (event) {
    
    const player = event.target;

    const fullscreenHandler = function () {
        if (document.webkitIsFullScreen || document.mozFullScreen ||
            document.msFullscreenElement != null || document.fullscreenEnabled) {
            document.querySelector('iframe.youtube').style.display = "block";
            
        } else {
            document.querySelector('iframe.youtube').style.display = "none";
            player.stopVideo()
        }
    }

    document.addEventListener('webkitfullscreenchange', fullscreenHandler, false);
    document.addEventListener('mozfullscreenchange', fullscreenHandler, false);
    document.addEventListener('fullscreenchange', fullscreenHandler, false);
    document.addEventListener('MSFullscreenChange', fullscreenHandler, false);

    document.getElementById('play-video').addEventListener("click", function () {
        
        player.seekTo(0);
        player.setLoop(true);
        player.playVideo();//won't work on mobile 

        var requestFullScreen = player.a.requestFullScreen || player.a.mozRequestFullScreen ||
            player.a.webkitRequestFullScreen || player.a.msRequestFullscreen;
        if (requestFullScreen) {
            requestFullScreen.bind(player.a)();
        }
    });
}

const BackgroundContent = styled.section `
    position: relative;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh; 
    overflow: hidden;

    video{
        min-width: 100%; 
        min-height: 100%;
        width: auto;
        height: auto;
        position: absolute;
    }
`

const Overlay = styled.div `
    width: 100vw;
    height: 100vh;
    position: absolute;  
    top: 0;
    background-color: rgba(0,0,0,0.5);
`

const ContentVideo = styled.div `
    position: absolute;  
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    h1 {
        font-size: 82px;
        color: #FFFFFF;
        font-family: Bazar;
        letter-spacing: 8px;

        @media screen and (max-width: 991px) {
            font-size: 60px;
        } 
    }

    h2 {
        text-align: center;
        max-width: 500px;
        color: #FFFFFF;
        font-size: 24px;
        margin-left: auto;
        margin-right: auto;
        font-weight: normal;

        @media screen and (max-width: 991px) {
            font-size: 20px;
        } 
    }

    h2 span {
        font-weight: bold;
    }
`

const Button = styled.div `
    margin-left: auto;
    margin-right: auto;
    padding: 15px 20px;
    border-radius: 5px;
    border: 1px solid #FFF;
    color: #FFF;
    transition: all 0.3s ease;
    max-width: 220px;
    margin-top: 30px;
    cursor: pointer;
    text-transform: uppercase;

    span {
        margin-right: 20px;
        font-size: 21px;
    }

    &:hover{
        color: #000;
        background-color: #FFF;
    }
`



// WEBPACK FOOTER //
// ./src/components/video/video.component.js